import { createSelector } from 'reselect';
import { defaultContextMap, defaultGroupContextMap, defaultGroupId } from 'reducers';

import ContactGroupTypes from './constants';


const filterType = (list, type) => list.filter(g => g.get('type') === type);

const checkState = state => state;

const selectContacts = createSelector(checkState, state => state.get('contacts'));

export const selectContact = createSelector(selectContacts, state => state.get('contact'));


export const selectContactTypes = createSelector(selectContacts, state => state.get('types'));

export const selectContactStatuses = createSelector(selectContacts, state => state.get('statuses'));

export const selectLoading = createSelector(selectContacts, state => state.get('loading'));

export const selectAppendJob = createSelector(selectContacts, state => state.get('appendJob'));

export const selectContactAssignableGroups = createSelector(selectContacts, state => state.get('groups').filter(g => g.get('type') === ContactGroupTypes.CONTACT && g.get('id')));

export const selectGroupContext = name => createSelector(selectContacts, s => s.getIn(['contexts', name], defaultContextMap).get('group') || defaultGroupContextMap);

export const selectGroups = createSelector(selectContacts, state => state.get('groups').filter(g => !!g.get('type')));

export const selectContactGroups = createSelector(selectGroups, groups => filterType(groups, ContactGroupTypes.CONTACT));

export const selectAppendGroups = createSelector(selectGroups, groups => filterType(groups, ContactGroupTypes.APPEND));

// Investor Lists (ATAI-180 / S10) — same `contact_groups` storage as Groups,
// filtered to the new INVESTOR type. Feeds both the Contacts sidebar section
// and the "Add to Investor List" modal's list picker.
export const selectInvestorGroups = createSelector(selectGroups, groups => filterType(groups, ContactGroupTypes.INVESTOR));

export const selectAssignableGroups = createSelector(selectContactGroups, groups => groups.filter(group => group.get('id') !== defaultGroupId));

// propstream-core extras for the contact currently open in the profile.
export const selectContactExtrasContactId = createSelector(selectContacts, (state) =>
  state.get('extrasContactId')
);

export const selectContactNote = createSelector(selectContacts, (state) => state.get('note'));

export const selectContactNoteLoaded = createSelector(selectContacts, (state) =>
  state.get('noteLoaded')
);

export const selectContactNoteSaving = createSelector(selectContacts, (state) =>
  state.get('noteSaving')
);

export const selectContactDocuments = createSelector(selectContacts, (state) =>
  state.get('documents')
);

export const selectContactDocumentUploading = createSelector(selectContacts, (state) =>
  state.get('documentUploading')
);

export const selectContactDocumentDeleting = createSelector(selectContacts, (state) =>
  state.get('documentDeleting')
);
